import { REVIEW_RATING_FILTER_ORDER } from '../consts';

/**
 * The ratings the Rating filter's picks stand for, in the filter's order. The filter carries each rating as text, so
 * five stars is picked as `'5'`; a value that is no rating is dropped.
 * @param values - Values picked in the Rating filter.
 */
export const parseRatingPicks = (values: readonly string[]) =>
  REVIEW_RATING_FILTER_ORDER.filter((rating) => values.includes(String(rating)));
